module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01@2x-415c273da546d13787edecb329a2c070.webp";